import * as types from "../constants/actionTypes";

export const setRoomFilters = filters => {
  return {
    type: types.GET_ROOM_FILTERS_SUCCESS,
    payload: filters
  };
};

export const resetRoomFilters = filters => {
  return {
    type: types.RESET_ROOM_FILTERS_SUCCESS,
    payload: filters
  };
};

export const setPlanFilters = filters => {
  return {
    type: types.GET_PLAN_FILTERS_SUCCESS,
    payload: filters
  };
};

export const setMaxPriceRangeFilters = price => {
  return {
    type: types.GET_MAX_PRICE_FILTERS_SUCCESS,
    payload: price
  };
};

export const setMinPriceRangeFilters = price => {
  return {
    type: types.GET_MIN_PRICE_FILTERS_SUCCESS,
    payload: price
  };
};

export const setHotelFilters = filters => {
  return {
    type: types.SET_HOTEL_FILTERS_SUCCESS,
    payload: filters
  };
};

export const setRegionFilters = filters => {
  return {
    type: types.SET_REGION_FILTERS_SUCCESS,
    payload: filters
  };
};



// WEBPACK FOOTER //
// ./src/actions/filterActions.js